export enum EAgentReferralQueryKey {
  GET_AGENT_REFERRAL_CODES = 'get-agent-referral-codes',
}
